import React from 'react';
import { Card } from 'react-bootstrap';

export const display = value => Number(value || 0).toLocaleString(undefined, { maximumFractionDigits: 2 });
export function Metrics({ counts, extra = [] }) {
  return <div className="analytics-metrics">{[
    ['Total Executions', counts.total], ['REST Executions', counts.rest], ['MCP Executions', counts.mcp],
    ['Successful', counts.successful], ['Failed', counts.failed], ...extra,
  ].map(([label, value]) => <Card key={label}><Card.Body><span>{label}</span><strong>{display(value)}</strong></Card.Body></Card>)}</div>;
}
export function Breakdowns({ counts }) {
  if (!counts.total) return null;
  return <div className="analytics-breakdowns">{[
    ['REST vs MCP', 'REST', counts.rest, 'MCP', counts.mcp],
    ['Success vs Failure', 'Success', counts.successful, 'Failure', counts.failed],
  ].map(([title, first, a, second, b]) => <Card key={title}><Card.Body><h3>{title}</h3>
    <div className="analytics-channel-bar" role="img" aria-label={`${first}: ${display(a)}; ${second}: ${display(b)}`}><span style={{ width: `${a / counts.total * 100}%` }} /><span style={{ width: `${b / counts.total * 100}%` }} /></div>
    <div className="analytics-legend"><span>{first} <strong>{display(a)}</strong></span><span>{second} <strong>{display(b)}</strong></span></div>
  </Card.Body></Card>)}</div>;
}
